import React, { useState, useEffect } from "react";
import { FaSyncAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import currentDomain from "../../../Utils/Utils";
import TableRow from "../../../Components/subcomponents/TableRow";
import EntryModal from "../../../Components/Modals/EntryModal"; // Import the Modal component

// "Yes (Square POS)" rather than a bare "Yes", so an admin reconciling the
// books can see how a car was paid for without opening it.
const paidLabel = (entry) => {
  if (!entry.ispaid) return "No";
  const detail = entry.payment_note || entry.payment_method;
  return detail ? `Yes (${detail})` : "Yes";
};


function ViewEntries() {
  const [searchQuery, setSearchQuery] = useState("");
  const [entries, setEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null); // State to track selected entry for modal
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility

  // Function to fetch entries from the backend
  const fetchEntries = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${currentDomain(location)}/api/entries?exclusive=true`
      );
      const data = await response.json();
      setEntries(data);
    } catch (error) {
      toast.error("Failed to fetch entries:");
    } finally {
      setIsLoading(false);
    }
  };

  // Initial fetch on component mount
  useEffect(() => {
    fetchEntries();
  }, []);

  // Handle refresh
  const handleRefresh = () => {
    fetchEntries(); // This will re-fetch the entries
  };

  // Function to open the modal and pass the selected entry data
  const handleEdit = (entry) => {
    setSelectedEntry(entry);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedEntry(null);
    fetchEntries();
  };

  // Function to filter and sort entries based on search query
  const filteredEntries = entries
    .filter((entry) => {
      const query = searchQuery.toLowerCase();
      const fullName =
        `${entry.owner_first_name} ${entry.owner_last_name}`.toLowerCase();
      const isPaidString = entry.ispaid ? "yes" : "no"; // Convert boolean to "Yes" or "No"

      if (["yes", "no"].includes(query.toLowerCase()))
        return isPaidString.includes(query);


      if (parseInt(query) < 1000 && query.length < 4) return parseInt(query) === entry.car_number;

      console.log(entry);
      return (
        fullName.includes(query) ||
        entry.make.toLowerCase().includes(query) ||
        entry.model.toLowerCase().includes(query) ||
        entry.year.toString().includes(query) ||
        entry.class_name.toLowerCase().includes(query) ||
        entry.owner_phone.includes(query) ||
        (entry.car_id.includes(query) && query.length >= 4) ||
        entry.class_name.toLowerCase().includes(query) || // Include class_name in the search
        (entry.payment_note || "").toLowerCase().includes(query) || // e.g. "square pos", "comped"
        isPaidString.includes(query) // Include isPaid ("Yes" or "No") in the search
      );
    })
    .sort((a, b) => {
      const query = searchQuery.toLowerCase();
      const aMatch =
        a.owner_first_name.toLowerCase().includes(query) ||
        a.make.toLowerCase().includes(query);
      const bMatch =
        b.owner_first_name.toLowerCase().includes(query) ||
        b.make.toLowerCase().includes(query);
      return aMatch === bMatch ? 0 : aMatch ? -1 : 1;
    });

  return (
    <div className="pb-8">
      <div className="text-center">
        <h1 className="font-bold text-2xl py-8">Entries</h1>
      </div>
      <div className="flex justify-between items-center pb-4">
        <input
          type="text"
          placeholder="Search by name, make, model, year, phone, class, or paid status..."
          className="border p-2 w-2/3"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button onClick={handleRefresh} className="">
          <FaSyncAlt />
        </button>
      </div>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <div className="overflow-auto pr-4">
          {" "}
          {/* Added a right padding here */}
          <table className="w-full border border-black">
            <thead>
              <tr className="bg-gray-200">
                <th className="text-xl">#</th>
                <th className="text-xl">Year</th>
                <th className="text-xl">Make & Model</th>
                <th className="text-xl">Class</th>
                <th className="text-xl">Owner</th>
                <th className="text-xl">Paid?</th>
                <th className="text-xl">Phone</th>
                <th className="text-xl"></th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {filteredEntries.length > 0 ? (
                filteredEntries.map((entry, index) => (
                  <TableRow
                    key={index}
                    year={entry.year}
                    make={entry.make}
                    model={entry.model}
                    className={entry.class_name}
                    owner={`${entry.owner_first_name} ${entry.owner_last_name}`}
                    isPaid={paidLabel(entry)}
                    phone={entry.owner_phone}
                    onEdit={() => handleEdit(entry)} // Open modal with entry details on Edit
                    num={entry.car_number}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    No matching entries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      <EntryModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        entry={selectedEntry}
      />
    </div>
  );
}

export default ViewEntries;
